import type { ReactNode } from 'react';
import type { TestId } from '@repo/test-id';
import classNames from 'classnames';

type DurationCardColor = 'brand' | 'white';

interface Props {
  children: ReactNode;
  testId: TestId;
  className?: string;
  color?: DurationCardColor;
  compact?: boolean;
  onClick?: () => void;
}

const colorClasses: Record<DurationCardColor, string> = {
  brand: 'bg-brand-softer text-fg-brand border-stroke-brand-subtle shadow-button ring ring-stroke-brand-subtle border',
  white: 'bg-primary-soft text-fg-brand border border-stroke-base-medium ',
};

const baseClasses = 'px-3 inline-flex items-center justify-between gap-2 text-lg font-medium cursor-pointer text-left';

export default function DurationCard({ testId, children, color = 'brand', className, compact, onClick }: Props) {
  const containerClasses = classNames(baseClasses, colorClasses[color], className, {
    'rounded-2xl py-4': !compact,
    'rounded-lg py-[9px]': compact,
  });

  return (
    <button type="button" className={containerClasses} data-testid={testId} onClick={onClick}>
      {children}
    </button>
  );
}
